import { VideoRequestInterface, ShareVideoResponse, INewNote, IUpdateLike } from '../interfaces/videoInterface';
import { USER_DECISION } from '../utils/enums';

import { axiosInstance, axiosInstanceHashedVideo } from '../utils/axiosInstance';
import { IReviewerDetails } from '../interfaces/reviewerInterface';
import { reviewerStorage } from '../utils/storage.utils';

export const getVideo = (shareCode: string):Promise<ShareVideoResponse> => axiosInstance.get(`/getVideoUrl?share=${shareCode}`).then((res) => res.data.data);

export const getVideos = (shareCode: string):Promise<ShareVideoResponse> => axiosInstance.get(`/shares/${shareCode}?email=${encodeURIComponent(reviewerStorage.getReviewer()?.email || '')}`).then((res) => res.data.data);

export const createReviewer = (reviewerDetails: IReviewerDetails) => axiosInstance.post('/shares/publicReviewer', reviewerDetails);

export const updateLike = (data: IUpdateLike) => axiosInstance.put('/like', data);

export const postNewNote = (data: { note: INewNote }) => axiosInstance.post('/newNote', data);

export const getHashedVideo = (params: URLSearchParams):Promise<VideoRequestInterface> => axiosInstanceHashedVideo.get('/getVideo', { params }).then((res) => res.data);

export const setDecision = (video_id:string, status: USER_DECISION):Promise<void> => axiosInstance.put('/integrations/status', { video_id, status });
